import React from 'react'

function Loader() {
    return (
        <div className="loader">Loading...</div>    )
}

export default Loader
